import { useLocation } from "react-router-dom";
import { useAppSelector } from "src/redux/storeHooks";
import { ROUTES_NAMES } from "src/utils/constants";

export const usePermission = () => {
    // current running scenario
    // save button isWrite delete button isDelete edit isRead 

    const { pathname } = useLocation();
    const location = useLocation();
    const { fetchedUserAccountData, fetchedUserStaffData } = useAppSelector((state) => state.userAccountData);

    let isRead: boolean = false;
    let isWrite: boolean = false;
    let isDelete: boolean = false;

    // Admin_Staff case for READ & WRITE 
    // When Main logged in with Admin_Staff (first phase step)
    const isAdminStaff = fetchedUserAccountData?.account_type === 'ADMIN_STAFF';
    // SUPERADMIN and WRITE conditions are same as of now the condition for SUPERADMIN is paused 
     if (isAdminStaff && fetchedUserAccountData?.role?.user_access === 'SUPERADMIN') {
        return { isRead: true, isWrite: true, isDelete: true }
    } else if (isAdminStaff && fetchedUserAccountData?.role?.user_access === 'WRITE') {
        return { isRead: true, isWrite: true, isDelete: true }
    } else if (isAdminStaff && fetchedUserAccountData?.role?.user_access === 'READ') {
        return { isRead: true, isWrite: false, isDelete: false }
    }

    // Admin_Staff logged in using Direct User Token case for READ & WRITE
    if (fetchedUserStaffData?.account_type === 'ADMIN_STAFF' && fetchedUserAccountData?.account_type === 'DIRECT') {
        if (fetchedUserAccountData?.parent_user_role?.customer_access === 'WRITE' || fetchedUserAccountData?.parent_user_role?.customer_access === "SUPERADMIN") {
            return { isRead: true, isWrite: true, isDelete: true }
        } else if (fetchedUserAccountData?.parent_user_role?.customer_access === 'READ') {
            return { isRead: true, isWrite: false, isDelete: false }
        } else {
            // other case if it comes other than READ WRITE
            return { isRead: false, isWrite: false, isDelete: false }
        }
    }

    // User_Staff
    const basePath = `/${pathname.split("/")[1]}`;
    const permissionKey = ROUTES_NAMES[basePath]
    const parentUserRole = fetchedUserAccountData?.parent_user_role;

    const access = parentUserRole?.[permissionKey];

    if (parentUserRole) {
        if (access === "READ") {isRead = true;isWrite = false; isDelete = false;}
        if (access === "WRITE") { isRead = true; isWrite = true; isDelete = false;}
        if (access === "FULL") { isWrite = true; isRead = true; isDelete = true; }
        if (access === "RESTRICT") { isRead = false; isWrite = false; isDelete = false }
    } else {
        // for DIRECT case No parent_user_role
        isRead = true; isWrite = true; isDelete = true;
    }
    return { isRead, isWrite, isDelete }
}